export default __webpack_public_path__ + "static/4-c1a36b1dd91bc2e3be3cdab5d0c9a4ea.jpeg";